import type { PropsWithChildren } from 'react';
import { playClawHomeUrl } from '@/lib/redirects';

type PlayClawAuthLayoutProps = PropsWithChildren<{
  redirectUrl: string;
}>;

const PlayClawAuthLayout = ({
  children,
  redirectUrl,
}: PlayClawAuthLayoutProps) => {
  const homeLinkLabel = 'Play Claw';
  const homeLinkUrl = playClawHomeUrl;
  const returnLinkLabel = 'Back to Play Claw';
  const returnLinkUrl = redirectUrl;

  return (
    <div className="auth-site-shell auth-site-shell--auth">
      <div className="auth-site-shell__background auth-site-shell__background--top" />
      <div className="auth-site-shell__background auth-site-shell__background--left" />
      <div className="auth-site-shell__background auth-site-shell__background--right" />
      <div className="auth-site-shell__content auth-site-shell__content--auth">
        <div className="auth-flow auth-flow--minimal">
          <div className="auth-flow__topbar auth-flow__topbar--minimal">
            <a className="auth-site-brand" href={homeLinkUrl}>
              <span className="auth-site-brand__eyebrow">DwellBot Games</span>
              <span className="auth-site-brand__name">{homeLinkLabel}</span>
            </a>
            <a className="auth-flow__return-link" href={returnLinkUrl}>
              {returnLinkLabel}
            </a>
          </div>
          <section className="auth-flow__card auth-flow__card--minimal" aria-label="Account form">
            <div className="auth-flow__card-surface">{children}</div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PlayClawAuthLayout;
